
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('circle',{attrs:{"cx":"4","cy":"4","r":"4"}}),_c('circle',{attrs:{"cx":"16","cy":"4","r":"4"}}),_c('circle',{attrs:{"cx":"28","cy":"4","r":"4"}})])])
          )
        }
      }
    